import React from "react";
import { Link } from "react-router-dom";
const ProductSpecs = () => {
  return (
          <div>
              {/* Spinner Start */}
             
              {/* Spinner End */}

          <div class="container container12">
          <div style={{ padding: "20px" }}>
            <h2 style={styles.heading}>Technical Specification</h2>

            <div style={styles.tableContainer}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>CHARACTERISTICS</th>
                            <th style={styles.th}>STANDARDS</th>
                            <th style={styles.th}>EN</th>
                            <th style={styles.th}>Result</th>
                            <th style={styles.th}>ASTM</th>
                            <th style={styles.th}>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        {technicalData.map((row, index) => (
                            <tr key={index}>
                                <td style={styles.td}>{row.characteristics}</td>
                                <td style={styles.td}>{row.standards}</td>
                                <td style={styles.td}>{row.en}</td>
                                <td style={styles.td}>{row.result}</td>
                                <td style={styles.td}>{row.astm}</td>
                                <td style={styles.td}>{row.astmResult}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

      
        </div>
        </div>
       
          <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
              <i className="bi bi-arrow-up"></i>
            </a>
        
        
              {/* Optional: Add any other content or components here */}
          
              <style>
                {`
                  /* Add your custom CSS here */
                  .service-item-top {
                    transition: transform 0.3s ease-in-out;
                  }
          
                  .service-item-top:hover {
                    transform: scale(1.05);
                  }
              .container12{
                  margin-top: 135px;}
                  /* Add any additional styling you want */
                `}
              </style>
            </div>
  );
};

const technicalData = [
  { characteristics: "Size", standards: "EN 427", en: "Pass", result: "", astm: "ASTM F536", astmResult: "Pass" },
  { characteristics: "Overall Thickness", standards: "EN 428", en: "Pass", result: "", astm: "ASTM F36", astmResult: "Pass" },
  { characteristics: "Wear Layer Thickness", standards: "EN 429", en: "Pass", result: "", astm: "ASTM F410", astmResult: "Pass" },
  { characteristics: "Dimension Squareness and Straightness", standards: "EN 427", en: "Pass", result: "Squareness: 0.18mm\nStraightness: 0.07mm", astm: "", astmResult: "" },
  { characteristics: "Chemical Resistance", standards: "EN 423", en: "Pass", result: "", astm: "ASTM F925, ASTM F1344", astmResult: "Pass" },
  { characteristics: "Colour Fastness to Artificial Light", standards: "EN20105:B02 Method A", en: "Pass, Grade 6", result: "", astm: "ASTM F1515", astmResult: "Pass" },
  { characteristics: "Castor Chair Suitability", standards: "EN 425", en: "Pass", result: "", astm: "", astmResult: "" },
  { characteristics: "Residual Indentation", standards: "EN 433", en: "Pass, 0.06mm", result: "", astm: "ASTM F1914, ASTM F970", astmResult: "Pass" },
  { characteristics: "Slip Resistance", standards: "EN 13893", en: "Class DS", result: "", astm: "ASTM D2047-93", astmResult: "Pass" },
  { characteristics: "Electrical Resistance", standards: "EN 1081 Method C", en: "Pass", result: "", astm: "ASTM F150-06", astmResult: "Pass" },
  { characteristics: "Thermal Resistance", standards: "EN 12664", en: "Pass", result: "", astm: "", astmResult: "" },
  { characteristics: "Toxic Element Test", standards: "EN 71-3", en: "Pass (Not toxic)", result: "Does not contain heavy metal and formaldehyde", astm: "", astmResult: "" },
  { characteristics: "Behaviour to Fire", standards: "ENISO11925-2, EN13501-1, EN ISO 9239-1", en: "Bf1-S1", result: "", astm: "ASTM E648-06", astmResult: "Pass/Class1" },
  { characteristics: "Smoke Density", standards: "", en: "", result: "", astm: "ASTM E662", astmResult: "Pass, <450" }
];

const productSizeData = [
  { size: "1220 x 181 mm", coreThickness: "4.00 mm to 6.00 mm", wearLayer: "0.3 mm (12mil) & 0.50 mm (20mil)", ixpe: "1 mm & 2 mm" }
];

const styles = {
  heading: {
      textAlign: "center",
      marginBottom: "20px",
      color: "#333",
      fontSize: "22px"
  },
  tableContainer: {
      overflowX: "auto",
      marginBottom: "20px"
  },
  table: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#fff",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      border: "1px solid #ddd"
  },
  th: {
      backgroundColor: "#17224D",
      fontWeight: "bold",
      padding: "12px",
      textAlign: "center",
      border: "1px solid #ddd",
      color: "#fff"
  },
  td: {
      padding: "12px",
      textAlign: "left",
      border: "1px solid #ddd"
  }
};

export default ProductSpecs;
